import "normalize.css";
import "./styles/application.module.scss";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Bootstrapper } from "PFApp/bootstrapper";
import { queryClient } from "PFCore/query_client";
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router";
import { RouterProvider } from "react-router/dom";

import { McpCallback } from "./mcp/mcp_callback/mcp_callback";

// we need to use createBrowserRouter to be able to use useBlocker
// https://stackoverflow.com/questions/75135147/react-router-dom-v6-useblocker
const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/oauth/mcp/callback" element={<McpCallback />} />
      <Route path="*" element={<Bootstrapper />} />
    </>
  )
);

const ReactApp = () => {
  const renderReactQueryDevTools = window.PF.config.enable_react_query_dev_tools;

  return (
    <QueryClientProvider client={queryClient}>
      {/* useTransitions disabled so route lazy-loads show the Suspense fallback, not a frozen screen */}
      <RouterProvider router={router} useTransitions={false} />
      {renderReactQueryDevTools && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
};

export default ReactApp;
